import SeatIconState from './SeatIconState';
import CharacterIcons from './CharacterIcons';
import Icons from './Icons';
import Badges from './Badges';
import SeatIcon from './SeatIcon';
import GraphicType from '../api/GraphicType';

function build(iconCharacter: string, graphicType: string) {
  if (graphicType === GraphicType.EmptySet) {
    const defaultState = new SeatIconState(Icons.EmptySet);
    return new SeatIcon(defaultState, undefined);
  }

  if (graphicType === GraphicType.Square) {
    const defaultState = new SeatIconState(Icons.Square);
    return new SeatIcon(defaultState, undefined);
  }

  if (graphicType === GraphicType.Circle) {
    const icon = CharacterIcons.getCharacterIcon({ iconCharacter });
    const defaultState = new SeatIconState(icon);
    const selectedState = new SeatIconState(Icons.Donut);

    return new SeatIcon(defaultState, selectedState);
  }

  if (graphicType === GraphicType.Wheelchair) {
    const icon = CharacterIcons.getCharacterIcon({ iconCharacter });
    const badge = Badges.Wheelchair;
    const defaultState = new SeatIconState(icon, badge);
    const selectedState = new SeatIconState(Icons.Donut, badge);

    return new SeatIcon(defaultState, selectedState);
  }

  if (graphicType === GraphicType.Star) {
    const icon = CharacterIcons.getCharacterIcon({ iconCharacter });
    const badge = Badges.Star;
    const defaultState = new SeatIconState(icon, badge);
    const selectedState = new SeatIconState(Icons.Donut, badge);

    return new SeatIcon(defaultState, selectedState);
  }

  throw new Error(`Graphic type ${graphicType} not recognized`);
}

export default {
  build,
};
